import React, { useContext } from 'react';
import Close from '../../../Icons/24x24/Close';
import IconButton from '../../../Buttons/IconButton';
import ModalCloseContext from '../../context';
const ModalCloseButton = ({ className })=>{
    const handleClose = useContext(ModalCloseContext);
    return /*#__PURE__*/ React.createElement(IconButton, {
        className: className,
        size: "large",
        "aria-label": "Close",
        icon: Close,
        onClick: handleClose
    });
};
ModalCloseButton.displayName = 'ModalCloseButton';
export default ModalCloseButton;

//# sourceMappingURL=ModalCloseButton.js.map